export default function formatTitleByLocale(
	locale: string,
	title?: string
): string {
	if (title) {
		switch (locale) {
			case 'de-DE':
				return `${title} | Audio Network DE`
			case 'en-AU':
				return `${title} | Audio Network AU`
			case 'en-GB':
				return `${title} | Audio Network UK`
			case 'en-US':
				return `${title} | Audio Network US`
			case 'es-ES':
				return `${title} | Audio Network ES`
			case 'fr-FR':
				return `${title} | Audio Network FR`
			case 'it-IT':
				return `${title} | Audio Network IT`
			case 'ja-JP':
				return `${title}`
			case 'pt-PT':
				return `${title} | Audio Network PT`
			case 'zh-CH':
				return `${title} | Audio Network CN`
			default:
				return `${title} | Audio Network`
		}
	} else {
		switch (locale) {
			case 'de-DE':
				return `Audio Network DE`
			case 'en-AU':
				return `Audio Network AU`
			case 'en-GB':
				return `Audio Network UK`
			case 'en-US':
				return `Audio Network US`
			case 'es-ES':
				return `Audio Network ES`
			case 'fr-FR':
				return `Audio Network FR`
			case 'it-IT':
				return `Audio Network IT`
			case 'ja-JP':
				return `Audio Network JP`
			case 'pt-PT':
				return `Audio Network PT`
			case 'zh-CH':
				return `Audio Network CN`
			default:
				return `Audio Network`
		}
	}
}
